import React, {
    useEffect,
    useContext,
    useCallback,
    memo,
    useMemo,
    useReducer,
    useState,
} from 'react';
import { withCookies } from 'react-cookie';
import { Portal } from 'react-portal';
import Traductor from 'components/Traductor';
import Modal from 'components/batches/Details/DetailsModal';
import Table from 'components/bronson/Table';
import VehicleDetails from 'components/auctions/ModalDetailVehicle/VehicleDetails';
import VehicleDetailService from 'services/VehicleDetailService';
import MaintenanceTableDetail from 'components/maintenance/MaintenanceTableDetail';
import Globals from '../../Globals';
import DetailsModal from '../batches/Details/DetailsModal';

const MaintenanceTable = ({ cookies, data: { keys, items }, vehicleId }) => {
    const t = useMemo(() => new Traductor(), []);
    const [showDetail, setShowDetail] = useState(false);
    const [error, setError] = useState(false);

    const getVehicleMaintenanceDetails = useCallback(async item => {
        const res = await new VehicleDetailService().getVehicleMaintenanceDetails(
            cookies.get(Globals.COOKIES.JWT)?.AccessToken,
            {
                idVehicle: vehicleId,
                InvoiceNumber: item.Factura,
                Dealer: item.Dealer,
            }
        );
        if (res == null) setError(true);
        else return res;
    }, []);

    return (
        <div className="c-table-wrapper  c-table--colored">
            <table>
                <thead>
                    <tr>
                        {keys
                            ? keys.map((key, i) => <th key={key}>{key}</th>)
                            : Object.keys(items[0]).map((key, i) => (
                                  <th key={key}>{t.getTraduction(key)}</th>
                              ))}
                    </tr>
                </thead>
                <tbody>
                    {items?.map(({ ...item }, i) => (
                        <tr key={i}>
                            {Object.values(item).map((value, i) => {
                                if (i == 3) return null;
                                return <td key={i}>{value}</td>;
                            })}
                            <td className="u-pb">
                                <button
                                    style={{
                                        border: 'none',
                                        background: 'unset',
                                    }}
                                    onClick={async () =>
                                        setShowDetail(
                                            await getVehicleMaintenanceDetails(
                                                item
                                            )
                                        )
                                    }
                                >
                                    <i
                                        className="c-icon c-icon--[control-magnifying-glass]"
                                        role="img"
                                        aria-hidden="true"
                                    />
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <Portal>
                <Modal
                    visible={showDetail}
                    onClose={() => setShowDetail(false)}
                    large
                    title="Detalles del mantenimiento"
                    content={
                        <MaintenanceTableDetail
                            data={{
                                keys: ['Concesionario', 'Concepto', 'Detalle'],
                                items: showDetail ? showDetail : null,
                            }}
                        />
                    }
                />
                <DetailsModal
                    visible={error}
                    large={false}
                    onActionPress={() => setError(null)}
                    onClose={() => setError(null)}
                    title={'No hay detalles'}
                    content={
                        'No se han encontrado detalles para el mantenimiento'
                    }
                    leftButton={t.getTraduction('Close')}
                />
            </Portal>
        </div>
    );
};

export default MaintenanceTable;
